import React from 'react';
import { Text } from '@ui-library';

export type CABPanelTab = 'config' | 'chat';

interface CABPanelTabsProps {
  activeTab: CABPanelTab;
  onTabChange: (tab: CABPanelTab) => void;
  disabled?: boolean;
}

export const CABPanelTabs: React.FC<CABPanelTabsProps> = ({
  activeTab,
  onTabChange,
  disabled = false,
}) => {
  const tabs = [
    {
      id: 'config' as CABPanelTab,
      label: 'CAB Configuration',
    },
    {
      id: 'chat' as CABPanelTab,
      label: 'BlueGenAI CAB Agent',
    },
  ];

  return (
    <div className="flex h-[56px] border-b border-border-secondary bg-bg-primary" role="tablist">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            role="tab"
            aria-selected={isActive}
            aria-controls={`panel-${tab.id}`}
            disabled={disabled}
            onClick={() => onTabChange(tab.id)}
            className={`
              flex-1 py-bg-v2-md px-bg-v2-lg border-b-2 transition-colors
              flex items-center justify-center gap-bg-v2-sm
              disabled:opacity-40 disabled:cursor-not-allowed
              ${isActive
                ? 'border-text-brand-primary -mb-[1px]'
                : 'border-transparent hover:text-text-secondary'
              }
            `}
          >
            <Text
              variant="text-sm"
              weight="semibold"
              className={isActive ? '!text-text-brand-primary' : '!text-text-tertiary'}
            >
              {tab.label}
            </Text>
          </button>
        );
      })}
    </div>
  );
};
